export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Cần tìm',
  frontPageProvideTitle: 'Cung cấp',
  frontPagePersonalCenterTitle: 'Hồ sơ',
  login: 'Đăng nhập',
  home_chatWithOctopie: 'Đang hiểu ý bạn',
  home_chatNeedUnderstood: 'Đã hiểu ý bạn',
  home_draftBannerTitle: 'Hoàn thiện tin nhắn của bạn',
  home_draftBannerSubtitle: 'AI đã soạn sẵn tin nhắn giúp bạn — chạm để tiếp tục',
  home_tabHome: 'Trang chủ',

  // App.vue
  appRequirementTitle: 'Chúng tôi lắng nghe mọi góp ý và phản hồi',
  appRequirementBtn: 'Gửi',
  appSubmitSuccess: 'Đã gửi thành công, cảm ơn phản hồi của bạn',
  appFeedbackLink: 'Góp ý/Phản hồi',
  mobile_banner_text: 'Trải nghiệm tốt nhất, hãy dùng ứng dụng của chúng tôi',
  mobile_banner_btn: 'Tải ứng dụng',

  // Common
  loading: 'Đang tải...',
  confirm: 'Xác nhận',
  cancel: 'Hủy',
  save: 'Lưu',
  delete: 'Xóa',
  edit: 'Chỉnh sửa',
  add: 'Thêm',
  search: 'Tìm kiếm',
  refresh: 'Làm mới',
  change_batch: 'Đổi một lượt',
  back: 'Quay lại',
  submit: 'Gửi',
  close: 'Đóng',
  ok: 'OK',
  yes: 'Có',
  no: 'Không',
  send: 'Gửi',
  block: 'Chặn',
  more: 'Thêm',
  logout: 'Đăng xuất',
  settings: 'Cài đặt',
  view_guide: 'Xem hướng dẫn',
  feedback: 'Phản hồi',
  feedback_title: 'Phản hồi',
  feedback_new: 'Phản hồi mới',
  feedback_empty: 'Chưa có phản hồi',
  feedback_hint: 'Hãy nói suy nghĩ của bạn...',
  feedback_submit: 'Gửi',
  feedback_submit_success: 'Đã gửi phản hồi thành công',
  feedback_submit_failed: 'Gửi phản hồi thất bại',
  feedback_reply_label: 'Phản hồi từ nền tảng',
  register: 'Đăng ký',
  name: 'Tên',
  email: 'Email',
  mobile: 'Số điện thoại',
  password: 'Mật khẩu',
  verification_code: 'Mã xác minh',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Mọi quyền được bảo lưu.',
  footerVersion: 'Phiên bản {version}',
  copy: 'Sao chép',
  regenerate: 'Tạo lại',
  generate: 'Tạo',
  contact_now: 'Trò chuyện',
  yours: 'bạn',
  xiaoyao_analysis: 'Phân tích bằng AI',
  brand_name: 'OctoSay',
  anonymous: 'Vô danh',
  no_summary: 'Không có tóm tắt',
  file: 'Tệp',
  discover: 'Khám phá',
  discover_title: 'Khám phá',
  discover_hotChannels: 'Kênh nổi bật',
  discover_allChannels: 'Tất cả',
  discover_searchChannel: 'Tìm kênh',
  discover_noChannels: 'Không có kênh nào',

  // Messages
  operationSuccess: 'Thao tác thành công',
  operationFailed: 'Thao tác thất bại',
  networkError: 'Lỗi mạng, vui lòng thử lại sau',
  dataLoadingFailed: 'Không thể tải dữ liệu',
  noData: 'Không có dữ liệu',
  deleteConfirm: 'Bạn có chắc muốn xóa không?',
  saveConfirm: 'Bạn có chắc muốn lưu không?',

  // Form Validation
  required: 'Trường này là bắt buộc',
  emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ',
  phoneInvalid: 'Vui lòng nhập số điện thoại hợp lệ',
  passwordTooShort: 'Mật khẩu phải có ít nhất {min} ký tự',
  passwordMismatch: 'Hai mật khẩu không khớp nhau',

  // Time
  today: 'Hôm nay',
  yesterday: 'Hôm qua',
  justNow: 'Vừa xong',
  minutesAgo: '{min} phút trước',
  hoursAgo: '{hour} giờ trước',
  daysAgo: '{day} ngày trước',

  // Footer
  about: 'Giới thiệu',
  footerPrivacy: 'Chính sách bảo mật',
  footerTerms: 'Điều khoản dịch vụ',
  footerSupport: 'Trợ giúp & hỗ trợ',

  // Register
  registerAgeConfirm: 'Tôi xác nhận mình đã đủ 13 tuổi',
  registerAgeConfirm18: 'Tôi xác nhận rằng tôi từ 18 tuổi trở lên',
  registerTermsPrefix: 'Tôi đã đọc và đồng ý ',
  registerTermsAnd: ' và ',
  registerAgeError: 'Vui lòng xác nhận độ tuổi của bạn',
  registerTermsError: 'Vui lòng đồng ý với điều khoản và chính sách bảo mật',

  // Chat
  chatPrivacyTip: 'Nhập tin nhắn bạn muốn nói vào hub, AI sẽ trò chuyện trước với bạn để làm rõ chi tiết. Sau khi bạn xác nhận, tin nhắn và tóm tắt AI được đăng cùng nhau, và AI tiếp tục tìm kiếm kết nối phù hợp cho bạn.',
  aiChat_quickSuggestions: 'Thử nói',
  aiChat_welcome: "Chào bạn! Cho mình biết bạn đang tìm gì nhé.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Đã hiểu chi tiết — xác nhận để đăng và tìm kết nối',
  aiChat_readyToPostHint: 'Tiếp tục trò chuyện để bổ sung chi tiết hoặc cập nhật tóm tắt bất cứ lúc nào',
  aiChat_progressStep1: 'Hiểu chi tiết',
  aiChat_progressStep1Done: 'Đã hiểu chi tiết',
  aiChat_progressStep2: 'Tóm tắt AI',
  aiChat_progressStep2Desc: "AI tạo bản tóm tắt để kết nối",
  aiChat_progressStep3: 'Đăng lên nhóm',
  aiChat_progressStep3Desc: 'Đăng và tìm kết nối của bạn',
  aiChat_publishExtraHint: 'Nhập thông điệp bạn muốn gửi tới hub',
  aiChat_publishMsgRequired: 'Bắt buộc',
  aiChat_publishMsgLabel: 'Thông điệp của bạn tới hub',
  aiChat_matchSummaryLabel: 'Tóm tắt AI',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Nội dung dưới đây do AI tạo, chỉ mang tính tham khảo.',
  aiChat_publishSuggestionHint: 'Chạm để thay thế',
  aiChat_allowDirectContact: 'Cho phép liên hệ trực tiếp',
  aiChat_allowDirectContactDesc: 'Người khác có thể liên hệ trực tiếp với bạn mà không cần ghép nối',
  channel_chat_session_publishToChannel: 'Đăng lên Nhóm Octo',
  aiChat_newChat: 'Đặt lại',

  // Channels / nhóm
  home_tabChannels: 'Nhóm Octo',
  channels_title: 'Nhóm Octo',
  channels_myChannels: 'nhóm đã tham gia',
  channels_discover: 'Khám phá',
  channels_noChannels: 'Chưa có hub',
  channels_noMyGroupsTitle: 'Bạn chưa tham gia hub nào',
  channels_noMyGroupsSubtitle: 'Tìm một hub để tham gia và bắt đầu kết nối bạn mới',
  channels_searchGroupsBtn: 'Tìm hub',
  channels_loginPrompt: 'Đăng nhập để xem hub',
  channels_create: 'Tạo Nhóm Octo',
  channels_search: 'Tìm Nhóm Octo',
  channels_searchMyGroups: 'Tìm Nhóm Octo của tôi',
  channels_searchHint: 'Tìm kiếm',
  channels_searchHintChats: 'Tìm trong trò chuyện...',
  channels_searchHintGroups: 'Tìm hub...',
  channels_searchHintMy: 'Tìm trong hub đã tham gia...',
  channels_joinByCode: 'Tham gia bằng mã',
  channels_joinByCodeTitle: 'Tham gia Nhóm Octo bằng mã',
  channels_joinByCodeHint: 'Nhập mã Nhóm Octo',
  channels_joinByCodeConfirm: 'Tham gia',
  channels_joinByCodeNotFound: 'Không tìm thấy hub',
  channels_createNewGroup: 'Tạo Nhóm Octo mới',
  channels_noResults: 'Không tìm thấy hub',
  channel_detail_join: 'Tham gia',
  channel_detail_leave: 'Rời khỏi',
  channel_detail_members: 'thành viên',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} đã tham gia nhóm',
  channelJoinMsg_twoJoined: '{name1} và {name2} đã tham gia nhóm',
  channelJoinMsg_multiJoined: '{name1}, {name2} và {n} người khác đã tham gia nhóm',
  channelJoinMsg_oneAndMoreJoined: '{name} và {n} người khác đã tham gia nhóm',
  channelJoinMsg_membersJoined: '{n} thành viên đã tham gia nhóm',

  // Feed
  channels_feed: 'Trò chuyện',
  channels_groups: 'Nhóm',
  feed_related: 'Liên quan',
  feed_recommend: 'Đề xuất',
  feed_empty: 'Chưa có nội dung, hãy khám phá các hub nổi bật',
  feed_goToGroup: 'Xem trong hub',
  feed_joinGroupAndSendMsg: 'Tham gia hub và gửi tin nhắn',
  channel_detail_channelCode: 'Mã Nhóm Octo',
  channel_detail_invitePhrase: 'Lời mời tham gia "{name}"\nMã mời {code} — mở ứng dụng để tự động tham gia · AI làm rõ chi tiết trước rồi tìm người phù hợp cho bạn',
  channel_detail_post: 'Đăng lên nhóm',
  channel_detail_aiHint: "Nhập tin nhắn của bạn trong hub và AI sẽ làm rõ chi tiết trước",
  channel_input_hint: 'Nói gì đó...',
  channel_leave_confirm_message: 'Bạn có chắc muốn rời khỏi hub này không? Bạn sẽ không nhận được tin nhắn từ hub nữa.',
  channel_invite_notFound: 'nhóm không tồn tại hoặc liên kết đã hết hạn',
  channel_invite_joinBtn: 'Tải ứng dụng OctoSay',
  channel_invite_hint: 'Tải ứng dụng, sau đó quét mã QR này hoặc tìm tên hub để tham gia',
  channel_invite_globalHintTitle: 'Bạn sắp tải phiên bản quốc tế',
  channel_invite_globalHintIOS: 'Ứng dụng này có thể không có trên App Store Trung Quốc. Hãy chuyển sang Apple Store ngoài Trung Quốc và tìm OctoSay, hoặc tải trực tiếp tệp APK bên dưới.',
  channel_invite_globalHintAndroid: 'Google Play có thể không truy cập được ở khu vực của bạn. Chúng tôi khuyên bạn nên tải trực tiếp tệp APK, hoặc thử Google Play.',
  channel_invite_globalHintDefault: 'Ứng dụng có thể không có trên cửa hàng ứng dụng địa phương. Chúng tôi khuyên bạn nên tải trực tiếp tệp APK, hoặc thử App Store.',
  channel_invite_globalBtnAppStore: 'Đến App Store',
  channel_invite_globalBtnGooglePlay: 'Đến Google Play',
  channel_invite_globalBtnAPK: 'Tải trực tiếp APK',
  channel_invite_defaultDesc: 'Tham gia {name} trên OctoSay',
  share: 'Chia sẻ',
  share_channel: 'Chia sẻ hub',
  share_channel_link: 'Chia sẻ liên kết',
  channel_detail_inviteCode: 'Mã mời',
  channel_detail_copyLink: 'Sao chép liên kết',
  share_session_title: 'Một bài đăng trên OctoSay',
  share_match_title: 'Một kết nối trên OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Xem {userName} đã đăng gì trên OctoSay',
  session_share_notFound: 'Bài đăng không tồn tại hoặc liên kết đã hết hạn',
  session_share_fromChannel: 'Từ Nhóm Octo',
  session_share_downloadBtn: 'Tải ứng dụng OctoSay',
  session_share_hint: 'Tải ứng dụng để xem toàn bộ bài đăng và tham gia hub',
  session_share_openInApp: 'Mở trong ứng dụng',
  toast_link_copied: 'Đã sao chép liên kết',
  toast_no_share_data: 'Không có nội dung để chia sẻ',
  channels_joinByQR: 'Mã QR',
  channels_joinByQRWebHint: 'Bản web chưa hỗ trợ quét mã QR. Vui lòng nhập mã hub để tham gia.',
  channels_joinByQRTitle: 'Tham gia bằng mã QR',
  channel_detail_qrCode: 'Mã QR',
  channel_detail_qrCodeSave: 'Lưu hình ảnh',
  channel_detail_qrCodeSaveHint: 'Nhấp chuột phải vào hình để lưu',
  channel_detail_qrCodeSaved: 'Đã lưu vào thư viện',
  channel_detail_qrCodeSaveFailed: 'Lưu thất bại, vui lòng thử lại',
  channel_detail_locateFailed: 'Không thể định vị tin nhắn',
  channel_detail_locateError: 'Lỗi khi định vị tin nhắn',
  channel_detail_myMessages: 'Tin nhắn của tôi',
  channel_detail_searchMessages: 'Tìm tin nhắn',
  channel_detail_aiChat: 'Trò chuyện với AI',
  channel_detail_matchHistory: 'Lịch sử ghép nối',
  channel_create_title: 'Tạo Nhóm Octo',
  channel_create_name: 'Tên Nhóm Octo',
  channel_create_description: 'Mô tả',
  channel_create_submit: 'Tạo',
  channelCreate_aiAssist: 'AI sẽ giúp bạn tạo một hub phù hợp',
  channelCreate_nameHint: 'Nhập tên cho hub của bạn',
  channelCreate_descHint: 'Mô tả hub của bạn làm gì',
  channelCreate_creating: 'Đang tạo...',
  channelCreate_created: 'Đã tạo hub!',
  channelCreate_failed: 'Tạo hub thất bại',
  channelCreate_welcomeMsg: "Chào bạn! Mình ở đây để giúp bạn tạo một hub. Hãy cho mình biết bạn muốn tạo hub như thế nào — tên, chủ đề hoặc mục đích — và mình sẽ giúp bạn biến nó thành tên hub và phần giới thiệu, đồng thời tạo ảnh đại diện.",
  channelCreate_aiHint: 'Viết chủ đề hub của bạn...',
  channelCreate_clarifyingProgress: 'Đang sắp xếp chủ đề hub của bạn...',
  channelCreate_readyToCreate: 'Sẵn sàng tạo Nhóm Octo',
  channelCreate_step1: 'Mô tả chủ đề',
  channelCreate_step1Done: 'Ý tưởng đã rõ ràng',
  channelCreate_step2: 'Tạo Nhóm Octo',
  channelCreate_confirmBtn: 'Xác nhận tạo',
  channelCreate_publicNotice: "nhóm là không gian công khai để những ngườicó cùng sở thích tụ họp và kết nối. Nền tảng có thể quản lý, cập nhật hoặc gộp các hub khi cần thiết. Cứ thoải mái chia sẻ hub này với những người quan tâm.",
  channelCreate_similarGroupsTitle: 'Phát hiện Nhóm Octo tương tự',
  channelCreate_similarGroupsDesc: 'Các hub này có thể phù hợp với bạn',
  channelCreate_exactMatchHint: 'Đã tồn tại hub có cùng tên!',
  channelCreate_joinHint: 'Những hub hiện có này có thể phù hợp với bạn',
  channelCreate_joinExisting: 'Tham gia Nhóm Octo hiện có',
  channelCreate_stillCreate: 'Vẫn tạo Nhóm Octo mới',
  channel_chat_session_comments: 'Bình luận',
  channel_chat_session_commentHint: 'Viết bình luận...',
  channel_chat_session_sendComment: 'Bình luận',
  channel_chat_session_loadMore: 'Tải thêm',
  channel_chat_session_noComments: 'Chưa có bình luận',
  channel_chat_session_deleteComment: 'Xóa',
  channelSearch_title: 'Tìm trong nhóm',
  channelSearch_placeholder: 'Tìm tin nhắn...',
  channelSearch_onlyMine: 'Chỉ bài đăng của tôi',
  channelSearch_tabAllMessages: 'Tin nhắn hub',
  channelSearch_tabMyMessages: 'Tin nhắn của tôi',
  chatMsgSearch_placeholder: 'Tìm tin nhắn',
  chatMsgSearch_tabMsgs: 'Tin nhắn',
  chatMsgSearch_tabContacts: 'Danh bạ',
  chatMsgSearch_emptyPrompt: 'Nhập từ khóa để tìm tin nhắn',
  chatMsgSearch_tooShort: 'Nhập ít nhất 2 ký tự để tìm kiếm',
  chatMsgSearch_contactEmptyPrompt: 'Nhập tên người dùng hoặc email để tìm danh bạ',
  chatMsgSearch_noContacts: 'Không tìm thấy danh bạ phù hợp',
  chatMsgSearch_inChatPlaceholder: 'Tìm trong cuộc trò chuyện này',
  channelHistory_title: 'Lịch sử',
  channelHistory_myMessages: 'Tin nhắn của tôi',
  channelHistory_loadMore: 'Tải thêm',
  channel_settings_push: 'Thông báo Nhóm Octo',
  channel_settings_commentPush: 'Thông báo bình luận',
  channel_settings_likePush: 'Thông báo lượt thích',
  channel_settings_receiveNotifications: 'Nhận thông báo',
  channel_settings_directContact: 'Cho phép liên hệ trực tiếp',
  session_published: 'Đã đăng',
  session_publishFailed: 'Đăng thất bại',
  session_setDirectContactSuccess: 'Đã lưu cài đặt',
  session_setDirectContactFailed: 'Lưu cài đặt thất bại',
  session_setPrivate: 'Đặt thành riêng tư',
  session_setPublic: 'Đặt thành công khai',
  session_pauseMatching: 'Tạm dừng ghép nối',
  session_resumeMatching: 'Tiếp tục ghép nối',
  session_matchPausedToast: 'Đã tạm dừng ghép nối',
  session_matchResumedToast: 'Đã tiếp tục ghép nối',
  match_matchingPausedTitle: 'Ghép nối đang tạm dừng',
  match_reasonTag: 'Lý do ghép nối',
  match_matchingPausedHint: 'Bạn có thể tiếp tục ghép nối bất cứ lúc nào.',
  session_confirmSetPrivate: 'Đặt nội dung này thành riêng tư? Người dùng khác sẽ không thể xem.',
  session_messageIsPrivate: 'Tin nhắn này là tin nhắn riêng tư',
  chatSessionComment_replyHint: 'Viết bình luận...',
  chatSessionComment_reply: 'Bình luận',
  chatSessionComment_count: '{n} bình luận',
  chatSessionMatch_count: '{n} kết nối',
  chatSessionComment_replyTo: 'Trả lời',
  chatSessionComment_inputHint: 'Viết bình luận...',
  chatSessionComment_send: 'Gửi',
  chatSessionComment_delete: 'Xóa',
  chatSessionComment_deleteConfirm: 'Bạn có chắc muốn xóa bình luận này không?',
  chatSessionComment_loadMore: 'Tải thêm',
  chatSessionComment_noMore: 'Không còn bình luận',
  chatSessionComment_loginToComment: 'Đăng nhập để bình luận',
  chatSessionComment_viewEarlier: 'Xem {n} phản hồi trước đó',
  chatSessionLike_like: 'Thích',
  chatSessionLike_liked: 'Đã thích',
  chatSessionLike_count: 'lượt thích',
  chatSessionBookmark_bookmark: 'Lưu',
  chatSessionBookmark_bookmarked: 'Đã lưu',
  chatSessionMatch_viewMatches: 'Xem kết nối',
  chatSessionMatch_matchHistory: 'Lịch sử ghép nối',
  chatSessionMatch_noMatches: 'Chưa có kết nối',
  channel_match_achievement: 'Đã ghép nối thành công {count} bài đăng',
  channel_match_achievement_view: 'Xem →',
  channel_matchHistory_title: 'Lịch sử ghép nối của kênh',
  chatSessionMatch_matchedAt: 'Ghép nối lúc {time}',
  discover_userMsgLabel: 'Người dùng nói',
  common_loading: 'Đang tải...',
  common_sending: 'Đang gửi...',
  common_error: 'Lỗi',
  common_success: 'Thành công',
  common_me: 'Tôi',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "AI đang làm rõ nhu cầu của bạn để đảm bảo mỗi tin nhắn đăng ra đều hiệu quả; sau khi đăng, AI sẽ tiếp tục kết nối bạn với người phù hợp",
  aiChat_clarifyingAlmostDone: 'Gần xong rồi, vui lòng xác nhận',
  aiChat_clarifyingOneMore: 'Chỉ còn khoảng 1 câu hỏi là có thể đăng',
  aiChat_clarifyingRemaining: 'Còn khoảng {count} lượt hỏi nữa, sắp xong rồi',
  aiChat_clarifyingEvaluating: 'Đang đánh giá tiến độ...',
  aiChat_setPublicMatch: 'Công khai và ghép nối',
  aiChat_needsClarifiedPublic: "Mình hiểu bạn rồi. Khi bạn xác nhận và đăng bài, AI sẽ tiếp tục tìm kết nối cho bạn.\nCứ thoải mái chia sẻ thêm chi tiết bất cứ lúc nào.",
  aiChat_needsClarifiedPrivate: 'Nắm được ý bạn rồi! Đặt công khai để AI tiếp tục tìm người phù hợp cho bạn!\nBạn có thể kể thêm chi tiết bất cứ lúc nào.',
  aiChat_setPublicTitle: 'Đặt thành công khai',
  aiChat_setPublicMessage: 'Nội dung của bạn sẽ hiển thị với người khác để OctoSay tìm được kết nối phù hợp.\n\nThông tin sẽ được chia sẻ:\n• Tên người dùng và ảnh đại diện\n• Tóm tắt nội dung của bạn\n• Nội dung cuộc trò chuyện (hiển thị trong Khám phá)\n\nBạn có thể đặt lại thành riêng tư bất cứ lúc nào.',
  aiChat_findMatches: 'Xem kết quả ghép nối',
  aiChat_publishing: 'Đang đăng...',
  aiChat_matchSectionTitle: 'Tin nhắn của bạn hợp với các nhóm này nhất — chạm để đăng',
  aiChat_joinedBadge: 'Đã tham gia',
  aiChat_matchSectionEmpty: 'Chưa có nhóm khớp tốt — bạn có thể tạo nhóm mới và đăng tại đó',
  aiChat_suggestPublishCreateNew: 'Tạo nhóm mới',
  aiChat_repickChannel: 'Đổi nhóm',
  aiChat_creatingChannelTitle: 'Chưa có nhóm phù hợp — đang tạo nhóm cho bạn',
  aiChat_creatingChannelHint: 'AI đang tạo nhóm theo yêu cầu của bạn, xong sẽ chuyển thẳng đến đăng — thường mất 10-30 giây',
  aiChat_publishToChannelHint: 'Sẽ được đăng vào "{name}"',
  aiChat_pickChannelTitle: 'Chọn nhóm để đăng',
  aiChat_matchingChannelTitle: 'Đang tìm nhóm phù hợp cho bạn',
  aiChat_matchingChannelHint: 'AI đang tìm kiếm dựa trên yêu cầu của bạn — thường mất vài giây đến nửa phút',
  aiChat_matchUnavailableTitle: 'Chưa thể đưa ra gợi ý',
  aiChat_matchUnavailableHint: 'Tìm nhóm bên dưới hoặc đóng rồi mở lại màn hình đăng',
  aiChat_waitSlowHint: 'Hơi chậm hơn bình thường nhưng vẫn đang xử lý — đợi thêm một chút hoặc tìm nhóm bên dưới',
  aiChat_creatingSlowHint: 'Tạo nhóm hơi chậm hơn bình thường nhưng vẫn đang xử lý — đợi thêm chút, xong sẽ đăng ngay',
  aiChat_pickChannelEmptyHint: 'Không tìm thấy nhóm phù hợp. Hãy tạo nhóm mới để đăng tin của bạn',
  aiChat_loadMore: 'Tải thêm',
  sidebar_publish: 'Đăng bài',
  chat_selectLocationOnMap: 'Vui lòng chọn vị trí trên bản đồ',

  // App.vue new
  placeholder_email: 'Nhập email',
  placeholder_mobile: 'Nhập số điện thoại',
  placeholder_password: 'Nhập mật khẩu',
  placeholder_name: 'Nhập tên của bạn',
  random_nickname: 'Ngẫu nhiên',
  placeholder_verification_code: 'Nhập mã xác minh',
  sending: 'Đang gửi...',
  registering: 'Đang đăng ký...',
  send_code: 'Gửi mã',
  retry_in_seconds: 'Thử lại sau {countdown}s',
  toast_enter_email: 'Vui lòng nhập email',
  toast_enter_mobile: 'Vui lòng nhập số điện thoại',
  toast_invalid_email: 'Vui lòng nhập email đúng định dạng',
  toast_invalid_mobile: 'Vui lòng nhập số điện thoại hợp lệ',
  toast_send_code_failed: 'Gửi mã xác minh thất bại',
  toast_code_sent: 'Đã gửi mã xác minh tới email',
  toast_code_sent_sms: 'Đã gửi mã xác minh tới điện thoại',
  toast_send_code_error: 'Gửi mã xác minh thất bại, vui lòng thử lại sau',
  toast_fill_all_fields: 'Vui lòng điền đầy đủ các trường',
  toast_login_failed: 'Đăng nhập thất bại',
  toast_login_success: 'Đăng nhập thành công',
  oauthOr: 'hoặc',
  toast_oauth_login_failed: 'Đăng nhập Google thất bại',
  toast_oauth_login_error: 'Lỗi đăng nhập Google, vui lòng thử lại',
  toast_login_error: 'Đăng nhập thất bại, vui lòng thử lại sau',
  toast_register_failed: 'Đăng ký thất bại',
  toast_register_success: 'Đăng ký thành công',
  toast_register_error: 'Đăng ký thất bại, vui lòng thử lại sau',

  // AdBanner.vue
  ad: 'Quảng cáo',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Trước khi kết nối',
  contactAd_gateSubtitle: 'Khoảnh khắc ngắn này giúp OctoSay luôn miễn phí — cảm ơn bạn đã ủng hộ!',
  contactAd_waitBtn: 'Tiếp tục sau {sec}s',
  contactAd_continueBtn: 'Tiếp tục trò chuyện',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Trò chuyện',

  // AiMatch.vue
  ai_welcome_msg: 'Xin chào, tôi là AI. Kể tôi nghe bạn đang nghĩ gì — tìm bạn cùng chơi, tìm đối tác, trao đổi kỹ năng, hay bất cứ điều gì.',
  default_username: 'Người dùng',

  // AvatarCropDialog.vue
  crop_hint: 'Chụm hai ngón để thu phóng, kéo để điều chỉnh',
  toast_crop_failed: 'Cắt ảnh thất bại',

  // ChatBox.vue
  loading_match_info: 'Đang tải thông tin ghép nối...',
  view_match_details: 'Xem chi tiết kết nối',
  step_clarify_needs: 'Làm rõ',
  step_ai_matching: 'Đăng lên nhóm',
  step_connect: 'Ghép nối bằng AI',
  make_private: 'Đặt thành riêng tư',
  setting: 'Đang cài đặt...',
  action_photo: 'Ảnh',
  action_file: 'Tệp',
  action_video: 'Video',
  action_location: 'Vị trí',
  hint_get_app: 'Tải app để giữ liên lạc',
  match_finding_title: 'Kết nối của bạn',
  match_finding_subtitle: 'AI đang tiếp tục tìm người phù hợp cho bạn',
  match_time_hint: 'Quá trình này thường mất 1-2 phút',
  match_result_stats: 'Đã tìm thấy {matched} kết nối tốt nhất{interested}',
  match_tap_to_connect: 'Chạm để bắt đầu cuộc trò chuyện',
  match_channel_hint: 'Đang ghép nối trong hub <strong>#{channel}</strong>. Ưu tiên cùng hub, nhưng khi cần cũng có thể bao gồm hub khác.',
  label_perfect_match: 'Kết nối tốt nhất',
  label_worth_a_look: 'Đáng xem',
  match_no_result_title: 'Đang tìm người phù hợp cho bạn',
  match_no_result_desc: 'Chia sẻ thêm chi tiết để OctoSay tìm được kết nối phù hợp. Cài app để nhận thông báo khi có người ghép nối với bạn.',
  go_back: 'Quay lại',
  no_public_requirements: 'Chưa có bài đăng công khai',
  channelEmpty_title: 'Ở đây vẫn đang im lặng',
  channelEmpty_subtitle: 'Hãy là người đầu tiên chia sẻ suy nghĩ',
  channelEmpty_hint: "Viết suy nghĩ của bạn và AI sẽ giúp bạn làm rõ và tiếp tục tìm kết nối, để tin nhắn của bạn không bị lãng quên",
  channelEmpty_action: 'Chia sẻ suy nghĩ của bạn',
  stay_connected: 'Giữ kết nối',
  download_app_desc: 'Tải app để trò chuyện và nhận thông báo ngay khi có người liên hệ với bạn!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'Tải trực tiếp APK',
  match_history: 'Lịch sử ghép nối',
  no_match_history: 'Chưa có lịch sử ghép nối',
  finding_matches: 'AI tiếp tục tìm người phù hợp - Sau khi đăng tin nhắn lên hub',
  discover_connect_hint: 'Bạn có thể trò chuyện với họ sau khi ghép nối thành công!',
  match_initializing: 'Đang khởi tạo...',
  placeholder_login_to_chat: 'đăng nhập và kể tôi nghe điều bạn đang nghĩ',
  toast_need_clear: 'Ý bạn đã rõ ràng!',
  toast_ai_responding: 'AI đang trả lời, vui lòng đợi...',
  toast_uploading_image: 'Đang tải ảnh lên, vui lòng đợi...',
  toast_uploading_file: 'Đang tải tệp lên, vui lòng đợi...',
  toast_max_photos: 'Tối đa {max} ảnh',
  toast_uploading: 'Đang tải lên, vui lòng đợi...',
  toast_file_too_large: '{name} vượt quá giới hạn 5MB',
  toast_video_too_large: '{name} vượt quá giới hạn 20MB',
  toast_video_processing: 'Đang xử lý video, vui lòng đợi…',
  toast_upload_link_failed: 'Không lấy được liên kết tải lên',
  analyzing_image: 'Đang phân tích ảnh...',
  toast_location_confirmed: 'Đã xác nhận vị trí',
  toast_location_selected: 'Đã chọn vị trí',
  toast_enter_search: 'Vui lòng nhập nội dung tìm kiếm',
  toast_search_failed: 'Tìm kiếm thất bại',
  toast_no_locations: 'Không tìm thấy vị trí',
  toast_search_error: 'Tìm kiếm thất bại, vui lòng thử lại',
  toast_located_at: 'Định vị tại: {address}',
  toast_shared_finding: 'Đã chia sẻ! Đang tìm kết nối...',
  toast_update_failed: 'Cập nhật thất bại',
  toast_set_private: 'Đã đặt thành riêng tư',
  toast_no_matches: 'Không tìm thấy kết nối',
  toast_matches_found: 'Đã tìm thấy {count} kết nối tốt nhất',
  toast_start_conversation_first: 'Hãy bắt đầu trò chuyện trước',
  toast_load_history_failed: 'Không thể tải lịch sử ghép nối',
  toast_ai_timeout: 'AI phản hồi quá lâu, vui lòng thử lại',
  toast_message_blocked: 'Tin nhắn đã bị chặn',
  network_disconnected: 'Mất kết nối mạng',
  toast_publish_success: 'Đã đăng lên hub!',
  toast_publish_failed: 'Đăng lên hub thất bại',

  // ChatMsgList.vue
  collapse_thinking: 'thu gọn quá trình suy nghĩ',
  expand_thinking: 'mở rộng quá trình suy nghĩ',
  thinking: 'đang suy nghĩ',
  select_date: 'Chọn ngày',
  selected_location: 'Vị trí đã chọn',
  msg_blocked: 'Đã chặn',
  retry: 'Thử lại',
  msg_read: 'Đã đọc',
  msg_sent: 'Đã gửi',
  msg_unread: 'Chưa đọc',
  label_start_datetime: 'Ngày và giờ bắt đầu:',
  label_end_datetime: 'Ngày và giờ kết thúc:',
  toast_select_start_datetime: 'Vui lòng chọn ngày và giờ bắt đầu',
  toast_end_before_start: 'Thời gian kết thúc không thể sớm hơn thời gian bắt đầu',
  report_message: 'Báo cáo tin nhắn',
  block_user: 'Chặn người dùng',
  msg_revoke: 'Thu hồi',
  msg_quote: 'Trích dẫn',
  msg_revoked_self: 'Bạn đã thu hồi một tin nhắn',
  msg_revoked_other: 'Người kia đã thu hồi một tin nhắn',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Tin nhắn đã được thu hồi',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Tin nhắn này đã bị nền tảng thu hồi do vi phạm quy định',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Đã thu hồi tin nhắn',
  toast_revoke_failed: 'Thu hồi tin nhắn thất bại',
  toast_load_data_failed: 'Không thể tải dữ liệu, vui lòng làm mới trang.',
  toast_file_url_missing: 'Không tìm thấy liên kết tệp',
  toast_block_success: 'Đã chặn người dùng thành công',
  toast_block_failed: 'Chặn người dùng thất bại',

  // ChatSession.vue
  no_more_records: 'không còn bản ghi nào.',
  title_needs_clarified: 'Suy nghĩ đã rõ ràng',
  title_clarifying: 'Đang giúp bạn làm rõ suy nghĩ',
  title_public: 'Công khai',
  title_private: 'Riêng tư',
  badge_clarified: 'Đã rõ ràng',
  badge_clarifying: 'Đang làm rõ',
  badge_only_me: 'Chỉ mình tôi',
  badge_expired: 'Đã hết hạn',
  title_expired: 'Đã hết hạn',
  no_chat_history: 'Chưa có lịch sử trò chuyện',

  // ContactMethods.vue
  block_status_banner: 'Bạn đã chặn người dùng này',
  unblock_user: 'Bỏ chặn',
  toast_block_missing_id: 'Không thể chặn: thiếu ID người dùng',
  dialog_block_confirm: 'Bạn có chắc muốn chặn {name} không? Bạn sẽ không nhận được tin nhắn nào từ người này.',
  toast_user_blocked: 'Đã chặn {name}',
  toast_unblock_missing_id: 'Không thể bỏ chặn: thiếu ID người dùng',
  toast_user_unblocked: 'Đã bỏ chặn {name}',

  // BlockedUsers.vue
  blocked_users: 'Người dùng đã chặn',
  blocked_users_empty: 'Chưa chặn ai',
  blocked_users_empty_hint: 'Người dùng bị bạn chặn sẽ không thể gửi tin nhắn cho bạn nữa',
  blocked_users_unblock: 'Bỏ chặn',
  dialog_unblock_confirm: 'Sau khi bỏ chặn, người kia có thể gửi tin nhắn cho bạn trở lại.',
  toast_unblock_success: 'Đã bỏ chặn',
  toast_unblock_failed: 'Bỏ chặn thất bại, vui lòng thử lại',
  blocked_users_load_failed: 'Tải thất bại. Chạm để thử lại',
  blocked_users_blocked_at: 'Đã chặn {date}',
  blocked_users_unknown_user: 'Người dùng không xác định',

  // Contacts.vue
  no_connections: 'Chưa có tin nhắn',
  chat_with: 'Trò chuyện với {name}',
  toast_load_contacts_failed: 'Không thể tải danh bạ: {msg}',
  toast_load_contacts_error: 'Không thể tải danh bạ. Vui lòng làm mới và thử lại.',
  time_just_now: 'Vừa xong',
  time_minutes_ago: '{min} phút trước',
  time_hours_ago: '{hour} giờ trước',
  time_days_ago: '{day} ngày trước',

  // InteractionNotification.vue
  interaction_notification_title: 'Thông báo',
  interaction_notification_subtitle: 'Bình luận và lượt thích',
  interaction_notification_empty: 'Chưa có thông báo',
  interaction_notification_comment: 'đã bình luận: {content}',
  interaction_notification_like: 'đã thích bài đăng của bạn',
  interaction_notification_reply: 'đã trả lời: {content}',
  interaction_notification_bookmark: 'đã lưu bài đăng của bạn',
  toast_load_notifications_failed: 'Không thể tải thông báo: {msg}',
  toast_load_notifications_error: 'Không thể tải thông báo. Vui lòng làm mới và thử lại.',
  mark_all_read: 'Đánh dấu tất cả là đã đọc',
  toast_mark_all_read_failed: 'Thao tác thất bại, vui lòng thử lại',
  contacts_dnd: 'Tắt thông báo',
  dnd_enabled: 'Đã tắt thông báo',
  dnd_disabled: 'Đã bật thông báo',
  dnd_action_enable: 'Tắt thông báo',
  dnd_action_disable: 'Bật thông báo',

  // Discover.vue
  toast_load_sessions_failed: 'Không thể tải phiên: {msg}',
  toast_load_sessions_error: 'Không thể tải phiên',
  discover_noMessages: 'Chưa có tin nhắn',

  // EmojiInputArea.vue
  placeholder_default: 'Chia sẻ thêm chi tiết với AI',
  userChat_typeMessage: 'Nhập tin nhắn...',
  select_emoji: 'Chọn biểu tượng cảm xúc',
  badge_new: 'mới',
  channel_search_placeholder: 'Nhập kênh',
  channel_picker_empty: 'Nhập kênh',

  // FrontPage.vue
  tab_chat_with_ai: 'Để OctoSay hiểu bạn',
  history_chats: 'Lịch sử',
  tab_connections: 'Kết nối',
  tab_conversations: 'Tin nhắn',
  tab_profile: 'Hồ sơ',
  new_session: 'Mới',
  history_tab_chats: 'Của tôi',
  history_tab_matches: 'Kết nối',
  channels_octosay: 'Nhóm Octo',
  tab_matches: 'Kết nối',
  tab_messages: 'Tin nhắn',

  // Header.vue
  slogan: 'OctoSay - AI hiểu bạn và kết nối bạn với người phù hợp',
  app_name: 'OctoSay',
  slogan_short: 'AI hiểu bạn và kết nối bạn với người phù hợp',
  slogan_ai: 'AI hiểu bạn và kết nối bạn với người phù hợp',
  get_the_app: 'Tải ứng dụng',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'hoặc tìm OctoSay trên các cửa hàng ứng dụng',

  // MapLocationPicker.vue
  placeholder_search_location: 'Tìm vị trí...',
  coords_display: 'Kinh độ: {lng}, Vĩ độ: {lat}',
  toast_no_geolocation: 'Trình duyệt của bạn không hỗ trợ định vị địa lý',
  toast_location_permission_denied: 'Không thể lấy vị trí của bạn, vui lòng kiểm tra quyền định vị',
  loading_address: 'Đang tải địa chỉ...',

  // MatchedSession.vue
  created_at: 'Đã tạo: {time}',
  ai_match_analysis: 'Phân tích kết nối của AI',
  error_missing_session_params: 'Thiếu tham số phiên bắt buộc',
  match_private_hint: 'Phiên này ở chế độ riêng tư. Không thể xem nội dung',

  // PersonalCenter.vue
  label_name: 'Tên:',
  placeholder_enter_name: 'Nhập tên của bạn',
  label_bio: 'Giới thiệu:',
  placeholder_enter_bio: 'Viết gì đó về bản thân',
  placeholder_bio_empty: 'Hãy chia sẻ đôi điều về bản thân',
  bio: 'Giới thiệu',
  delete_account: 'Xóa tài khoản',
  delete_warning: 'Hành động này không thể hoàn tác.',
  delete_data_intro: 'Dữ liệu sau đây sẽ bị xóa vĩnh viễn:',
  delete_item_profile: 'Thông tin hồ sơ của bạn',
  delete_item_chat: 'Lịch sử trò chuyện và phiên',
  delete_item_contact: 'Thông tin liên hệ',
  delete_item_all: 'Tất cả dữ liệu liên quan',
  final_confirmation: 'Xác nhận lần cuối',
  delete_confirm_prompt: 'Nhập "delete" để xác nhận:',
  placeholder_type_delete: 'Gõ delete',
  private_token: 'Mã truy cập riêng',
  token_desc: 'Tạo mã truy cập để dùng API',
  toast_not_logged_in: 'Người dùng chưa đăng nhập',
  toast_name_required: 'Tên không được để trống',
  toast_save_success: 'Lưu thành công',
  toast_save_failed: 'Lưu thất bại',
  toast_image_too_large: 'Ảnh vượt quá giới hạn 5MB',
  toast_avatar_updated: 'Đã cập nhật ảnh đại diện',
  toast_avatar_failed: 'Cập nhật ảnh đại diện thất bại',
  toast_upload_failed: 'Tải lên thất bại',
  toast_token_generated: 'Đã tạo mã truy cập',
  toast_token_failed: 'Tạo mã truy cập thất bại',
  toast_copied: 'Đã sao chép vào bộ nhớ tạm',
  toast_copy_failed: 'Sao chép thất bại',
  toast_account_deleted: 'Đã xóa tài khoản thành công',
  toast_delete_account_failed: 'Xóa tài khoản thất bại',
  toast_logout_success: 'Đăng xuất thành công',
  toast_logout_failed: 'Đăng xuất thất bại',
  profile_tab_messages: 'Tin nhắn',
  profile_tab_comments: 'Bình luận',
  profile_tab_likes: 'Lượt thích',
  profile_tab_bookmarks: 'Đã lưu',
  profile_empty_messages: 'Chưa đăng tin nhắn nào',
  profile_empty_comments: 'Chưa có bình luận nào',
  profile_empty_likes: 'Chưa thích bài nào',
  profile_empty_bookmarks: 'Chưa lưu bài nào',
  profile_reply_to: 'Trả lời {name}',
  profile_stats_posts: 'Tin nhắn',
  profile_stats_comments: 'Bình luận',
  profile_stats_likes: 'Lượt thích nhận được',
  profile_joined: 'Tham gia {date}',

  // ReportDialog.vue
  report_message_title: 'Báo cáo tin nhắn',
  report_reason_prompt: 'Vui lòng chọn lý do báo cáo tin nhắn này:',
  report_spam: 'Tin rác',
  report_harassment: 'Quấy rối hoặc bắt nạt',
  report_inappropriate: 'Nội dung không phù hợp',
  report_other: 'Khác',
  placeholder_report_desc: 'Mô tả vấn đề (không bắt buộc)',
  toast_select_reason: 'Vui lòng chọn lý do',
  toast_report_success: 'Đã gửi báo cáo thành công',
  toast_report_failed: 'Gửi báo cáo thất bại',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Ảnh]',
  summary_images: '[Ảnh x{count}]',
  summary_file: '[Tệp]',
  summary_files: '[Tệp x{count}]',
  summary_video: '[Video]',
  summary_videos: '[Video x{count}]',
  summary_location: '[Vị trí]',
  summary_locations: '[Vị trí x{count}]',
  summary_emoji: '[Biểu tượng]',
  summary_emojis: '[Biểu tượng x{count}]',
  summary_voice: '[Tin nhắn thoại]',
  summary_voices: '[Tin nhắn thoại x{count}]',
  summary_mixed: '[Nội dung kết hợp]',
  summary_other: '[Khác]',

  // Voice messages
  voice: 'Tin nhắn thoại',
  voice_recording: 'Đang ghi âm...',
  toast_voice_too_short: 'Bản ghi quá ngắn',
  toast_voice_failed: 'Gửi tin nhắn thoại thất bại',
  toast_mic_permission_denied: 'Không thể truy cập micro. Vui lòng bật quyền trong cài đặt trình duyệt',
  toast_recording_not_supported: 'Trình duyệt này không hỗ trợ ghi âm',
  voice_load_failed: 'Không thể tải tin nhắn thoại',

  // Expire At
  aiChat_expireLine: "Có hiệu lực đến {date}, nói với AI bất cứ lúc nào để cập nhật",
  aiChat_expireExpired: "Nội dung đã hết hạn và không còn hiển thị với người khác. Nói với AI bất cứ lúc nào để cập nhật thờihạn",

  // MatchedSession.vue
  detail: 'Chi tiết',

  // Match notification hints
  match_new_result_hint: 'Nếu có kết quả ghép nối mới, bạn sẽ được thông báo qua email. Để có trải nghiệm tốt hơn, hãy cài app để nhận thông báo tức thời.',

  // Match notification hints
  match_connection_notify_hint: 'Đã ghép nối và thông báo! Nhanh lên, chào người ấy đi!',
  match_continuousMatching: "AI đang liên tục tìm kết nối cho bạn",
  match_continuousMatchingHint: 'Sẽ báo bạn ngay khi có kết quả mới',
  match_continuousMatchingOthers: "AI đang liên tục tìm kết nối cho họ",
  match_continuousMatchingOthersHint: 'Kết quả mới sẽ hiển thị tại đây khi có',
  match_noResultsTitleOthers: 'Đang tìm người phù hợp cho người ấy',
  match_noResultsHintOthers: "AI đang liên tục tìm kết nối cho họ. Kết quả sẽ xuất hiện tại đây khi tìm thấy.",
  match_newMatchFound: 'Phát hiện {n} kết nối mới!',
  match_worth_exploring_hint: 'Việc chủ động liên hệ hay không là do bạn quyết định.',

  // Matches filter tags
  filter_all: 'Tất cả',
  filter_best_connection: 'Kết nối tốt nhất',
  filter_worth_a_look: 'Đáng xem',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - AI hiểu bạn và kết nối bạn với người phù hợp',
  landing_hero_title: 'Viết trong hub của bạn — AI làm rõ trước, bạn xác nhận rồi đăng kèm tóm tắt',
  landing_hero_subtitle: 'Nhập điều bạn muốn nói vào Nhóm Octo. Trước khi đăng, AI sẽ trò chuyện với bạn để làm rõ chi tiết. Sau khi bạn xác nhận, tin nhắn gốc và tóm tắt AI được đăng cùng nhau lên hub, rồi AI tiếp tục tìm người phù hợp cho bạn',
  landing_download_on: 'Tải trên',
  landing_get_it_on: 'Có trên',
  landing_direct_download: 'Tải trực tiếp',
  landing_how_title: 'Ba bước sử dụng',
  landing_step1_title: 'Viết trong nhóm',
  landing_step1_desc: 'Nhập nội dung bạn muốn thể hiện trong hub. Tin nhắn sẽ không được gửi ngay, AI sẽ trò chuyện trước để làm rõ chi tiết, giúp mỗi tin nhắn đều rõ ràng, hữu ích và đáng để ghép nối — thay vì chìm trong đống tin nhắn linh tinh.',
  landing_step2_title: 'Xác nhận rồi đăng và ghép nối',
  landing_step2_desc: 'Sau khi bạn xác nhận, tin nhắn gốc và tóm tắt ghép nối do AI đúc kết sẽ được đăng cùng nhau lên hub. AI sau đó liên tục tìm người phù hợp nhất cho bạn, tránh để tin nhắn chìm đi chẳng ai xem.',
  landing_step3_title: 'Ghép nối xong thì tự nhiên trò chuyện',
  landing_step3_desc: 'Sau khi ghép nối thành công, cả hai đều thấy lịch sử trò chuyện với AI và tóm tắt của nhau. Có bối cảnh chung nên phá băng tự nhiên, không gượng ép, trò chuyện dễ chịu hơn.',
  // Comparison Section
  landing_comparison_title: 'Vì sao chọn OctoSay?',
  landing_comparison_subtitle: 'Chat theo dạng hub, nhưng AI giúp làm rõ chi tiết và chủ động ghép nối.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Chất lượng nội dung',
  landing_cmp1_other: 'Quảng cáo, chém gió, tin lệch chủ đề tràn ngập',
  landing_cmp1_octo: 'Chỉ hiển thị thẻ nhu cầu do AI sàng lọc',
  landing_cmp2_label: 'Tìm người',
  landing_cmp2_other: 'Đăng xong ngồi cầu nguyện có người xem',
  landing_cmp2_octo: 'AI chủ động ghép người phù hợp cho bạn',
  landing_cmp3_label: 'Mức độ nhiễu',
  landing_cmp3_other: 'Phải lướt qua hàng trăm tin nhắn',
  landing_cmp3_octo: 'Không nhiễu, mỗi tin nhắn đều có ý nghĩa',
  landing_cmp4_label: 'Độ khó khi mới dùng',
  landing_cmp4_other: 'Tìm server, lướt kênh, tự mò',
  landing_cmp4_octo: 'Viết tin trong hub, AI làm rõ và ghép nối',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Tin nhóm tràn ngập quảng cáo, chém gió',
  landing_cmp1_xhs: 'Bài marketing nhiều, khó phân biệt thật giả',
  landing_cmp1_facebook: 'Quảng cáo và giật tít ngập newsfeed',
  landing_cmp1_reddit: 'Spam, bài lệch chủ đề khắp nơi',
  landing_cmp2_wechat: 'Chỉ dựa vào danh bạ và rủ vào nhóm',
  landing_cmp2_xhs: 'Phải tự tìm và lướt từ từ',
  landing_cmp2_facebook: 'Bó hẹp trong bạn bè và nhóm sẵn có',
  landing_cmp2_reddit: 'Tự lướt mục, đăng bài chờ phản hồi',
  landing_cmp3_wechat: 'Lướt hàng trăm tin nhắn nhóm',
  landing_cmp3_xhs: 'Dòng thông tin toàn đề xuất và quảng cáo',
  landing_cmp3_facebook: 'Bài đề xuất và quảng cáo xem không hết',
  landing_cmp3_reddit: 'Phải lướt hàng trăm bình luận',
  landing_cmp5_label: 'Cách tìm người',
  landing_cmp5_wechat: 'Tự hỏi từng người, cầu may',
  landing_cmp5_xhs: 'Đăng bài chờ bình luận, còn phải tự lọc',
  landing_cmp5_facebook: 'Phải tự đi hỏi khắp nhóm',
  landing_cmp5_reddit: 'Tự đăng bài, chờ phản hồi, rồi lọc',
  landing_cmp5_octo: 'AI tự động và liên tục tìm người giúp bạn',

  landing_features_title: 'Tính năng nổi bật',
  landing_feature1_title: 'Làm rõ trước khi đăng',
  landing_feature1_desc: 'Không cần điền biểu mẫu. Viết điều bạn muốn nói trong hub, AI sẽ trò chuyện, hỏi chi tiết trước khi đăng để thực sự hiểu nhu cầu của bạn',
  landing_feature2_title: 'Ghép nối Nhóm Octo',
  landing_feature2_desc: 'Tin nhắn và tóm tắt ghép nối được đăng cùng nhau lên Nhóm Octo, OctoSay liên tục tìm trong nhóm thành viên câu trả lời hoặc người đồng cảm cho bạn và giải thích vì sao phù hợp',
  landing_feature3_title: 'Ghép nối chủ động',
  landing_feature3_desc: 'Sau khi bạn xác nhận đăng, AI sẽ liên tục tìm người hợp cạ trong hub giúp bạn, không cần bạn tự tìm hay lướt',
  landing_feature4_title: 'Cộng đồng Nhóm Octo',
  landing_feature4_desc: 'Tham gia các Nhóm Octo bạn quan tâm để lấy câu trả lời, tìm bạn đồng hành, kết nối tự nhiên và ấm áp hơn',
  landing_feature5_title: 'Bảo vệ quyền riêng tư',
  landing_feature5_desc: 'Sau khi gửi có thể đặt thành riêng tư, chỉ mình bạn thấy, toàn quyền kiểm soát thông tin của mình',
  landing_feature6_title: 'Giao tiếp hiệu quả',
  landing_feature6_desc: 'Không nhiễu, không tin rác, mỗi tin nhắn đều có ý nghĩa',
  landing_usecases_title: 'Phù hợp mọi tình huống',
  landing_usecases_subtitle: 'Dù bạn muốn làm gì, cần gì, AI đều hiểu và giúp bạn xử lý',
  landing_usecase_game: 'Bạn chơi game',
  landing_usecase_language: 'Trao đổi ngôn ngữ',
  landing_usecase_skill: 'Trao đổi kỹ năng',
  landing_usecase_roommate: 'Tìm người ở ghép',
  landing_usecase_travel: 'Bạn du lịch',
  landing_usecase_sports: 'Bạn tập thể thao',
  landing_usecase_study: 'Bạn học',
  landing_usecase_anything: '...hoặc chia sẻ bất cứ điều gì',
  landing_cta_title: 'Sẵn sàng chưa?',
  landing_cta_desc: 'Tham gia Nhóm Octo, viết điều bạn muốn nói, để AI làm rõ trước, bạn xác nhận rồi đăng, và tiếp tục giúp bạn tìm đúng người. Bắt đầu ngay.',
  landing_use_now: 'Dùng ngay',
  landing_groups: 'Nhóm Octo',

  // OnboardingPage.vue
  onboarding_skip: 'Bỏ qua',
  onboarding_next: 'Tiếp',
  onboarding_getStarted: 'Bắt đầu',
  onboarding_step1Title: "Nói rõ nhu cầu của bạn trong nhóm",
  onboarding_step1Desc: "Bạn đang tìm gì hay muốn làm gì, cứ nói thẳng. AI sẽ trò chuyện để làm rõ chi tiết và tổng hợp thành một nhu cầu rõ ràng.",
  onboarding_step2Title: 'Xác nhận rồi đăng và ghép nối',
  onboarding_step2Desc: "Khi tin nhắn của bạn được đăng lên hub, AI sẽ liên tục tìm những kết nối phù hợp nhất cho bạn, để tin nhắn không bị chôn vùi hay bỏ qua.",
  onboarding_step3Title: 'Ghép nối xong thì tự nhiên trò chuyện',
  onboarding_step3Desc: "Cả hai bên đều có thể xem cuộc trò chuyện của nhau với AI và biết đối phương đang tìm gì. Với ngữ cảnh chung, việc bắt chuyện trở nên dễ dàng — cứ trò chuyện một cách tự nhiên.",

  // ChannelDetail.vue
  channel_image_limit: 'Tối đa 1 ảnh',

  // ChannelMembers.vue
  channel_members_empty: 'Chưa có thành viên',
  channel_members_title: 'Thành viên',
  channel_role_owner: 'Chủ nhóm',
  channel_role_admin: 'Quản trị viên',
  channel_role_member: 'Thành viên',

  // Settings.vue
  settings_language: 'Ngôn ngữ',
  settings_language_followSystem: 'Theo hệ thống',

  // ChatBox.vue
  match_interested_suffix: ', {count} đáng xem',

  // ChatBox.vue - Các giai đoạn tiến trình ghép đôi AI
  match_stage_fetch_chat: 'Đang lấy hội thoại',
  match_stage_query_expansion: 'Mở rộng truy vấn',
  match_stage_semantic_search: 'Tìm kiếm ngữ nghĩa',
  match_stage_deep_search: 'Phân tích chuyên sâu',
  match_stage_rerank: 'Ghép đôi thông minh',
  match_stage_refining: 'Tối ưu kết quả',
  match_stage_fetch_details: 'Đang lấy chi tiết',

  // ChannelDetail.vue - Tải ảnh lên
  channel_select_image: 'Vui lòng chọn tệp hình ảnh',
  channel_image_upload_failed: 'Tải ảnh lên thất bại, vui lòng thử lại',
  chatInput_channelSearchHint: "Tìm nhóm",
}



// WEBPACK FOOTER //
// ./src/i18n/vi.js